export const environment = {
  production: true,
  development: false,
  version: '1.0.0',

  // API Configuration
  api: {
    baseUrl: 'https://taselith.com',
    timeout: 30000,
    retryAttempts: 3,
  },

  // Database Configuration
  database: {
    name: 'CairnDB',
    version: 1,
    maxRetries: 5,
    retryDelay: 2000,
  },

  // Map Configuration
  map: {
    defaultTileServer: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '© OpenTopoMap contributors',
    defaultCenter: [39.7392, -104.9903], // Denver, CO
    defaultZoom: 10,
    maxZoom: 18,
    minZoom: 5,
  },

  // Offline Storage Configuration
  storage: {
    quotaThresholdMB: 1000, // Request persistent storage above this
    cleanupThresholdMB: 2000, // Start cleanup above this
    maxOfflineMapsMB: 5000, // Maximum offline maps storage
  },

  // Synchronization Configuration
  sync: {
    enableBackgroundSync: true,
    syncIntervalMs: 60000, // 1 minute
    maxRetryAttempts: 10,
    batchSize: 100,
  },

  // Feature Flags
  features: {
    enableMeshNetworking: true,
    enableCloudSync: true,
    enableAnalytics: true,
    enablePushNotifications: true,
    enableBetaFeatures: false,
  },

  // Logging Configuration
  logging: {
    level: 'warn',
    enableConsoleLog: false,
    enableFileLog: true,
    maxLogFileSizeMB: 50,
  },

  // Security Configuration
  security: {
    enableBiometrics: true,
    sessionTimeoutMs: 7200000, // 2 hours
    maxLoginAttempts: 3,
  },

  // Development Tools
  devTools: {
    enableReduxDevTools: false,
    enablePerformanceMonitoring: false,
    enableNetworkInspection: false,
  },
}
